import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import { selectSeriesInfoForCurrentBib } from 'app/selectors/bibs/SeriesInfoSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { fetchSeriesInfo } from 'app/actions/SeriesInfoActions';
import { sameSeriesShape } from 'app/shapes/bibPage';
import SameSeriesOverlay from './SameSeriesOverlay';

export class SameSeriesOverlayContainer extends React.PureComponent {
  render() {
    return <SameSeriesOverlay {...this.props} />;
  }
}

SameSeriesOverlayContainer.propTypes = {
  catalogBib: catalogBibShape,
  fetchSeriesInfo: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  series: sameSeriesShape.isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  isFetching: state.getIn(['bibs', 'seriesInfo', 'isFetching'], false),
  series: selectSeriesInfoForCurrentBib(state)
});

const mapDispatchToProps = {
  fetchSeriesInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(SameSeriesOverlayContainer);
